import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CrcPipe } from '../../../../shared/pipes/crc.pipe';
import { ShoppingBag, LucideIconData } from 'lucide-angular';
import type { BlogPost } from '../../../../shared/models/blog.model';
import { BLOG_COPY } from '../../constants/blog.constants';
import { IconComponent } from '../../../../shared/ui/icon/icon.component';
import { NewsletterFormComponent } from '../../../../shared/ui/newsletter-form/newsletter-form.component';
import { toBlogProductView, toStoreCategoryViews } from '../../utils/blog-links.util';

@Component({
  selector: 'app-article-sidebar',
  imports: [RouterLink, CrcPipe, IconComponent, NewsletterFormComponent],
  templateUrl: './article-sidebar.component.html',
  styleUrl: './article-sidebar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ArticleSidebarComponent {
  post = input.required<BlogPost>();
  protected readonly shoppingBagIcon: LucideIconData = ShoppingBag;
  protected readonly copy = BLOG_COPY;

  /**
   * Relacionados tal cual llegan: la fuente ya filtra los no publicables,
   * respeta el orden del pivot y recorta a 4 (B68, B69).
   */
  protected readonly relatedProducts = computed(() =>
    this.post().relatedProducts.map(toBlogProductView),
  );

  /** «Explorar en tienda»: solo las categorías con enlace válido (B71). */
  protected readonly storeCategories = computed(() =>
    toStoreCategoryViews(this.post().relatedStoreCategories),
  );
}
